import React from 'react'
import { Modal as BootstrapModal } from 'react-bootstrap'
import { Button } from '../../../components/Button/Button'
import { FieldDescriptor } from '../../../models/AiFeature'

interface CrmMappingModalHeaderProps {
  selectedIntegration: string | null | undefined
  integrationLabels: Record<string, string>
}

export const CrmMappingModalHeader: React.FC<CrmMappingModalHeaderProps> = ({ selectedIntegration, integrationLabels }) => {
  return (
    <BootstrapModal.Header closeButton>
      <BootstrapModal.Title>
        Configure CRM mapping to {selectedIntegration ? (integrationLabels[selectedIntegration] ?? selectedIntegration) : 'None selected'}
      </BootstrapModal.Title>
    </BootstrapModal.Header>
  )
}

interface CrmMappingModalFooterProps {
  onCancel: () => void
  onApply: () => void
}

export const CrmMappingModalFooter: React.FC<CrmMappingModalFooterProps> = ({ onCancel, onApply }) => {
  return (
    <BootstrapModal.Footer className='d-flex justify-content-between align-items-center w-100'>
      <div className='text-muted small d-flex align-items-center gap-1'>
        <i className='bi bi-info-circle' />
        Settings will be saved when you save the form
      </div>
      <div className='d-flex gap-2'>
        <Button variant='secondary' onClick={onCancel}>
          Cancel
        </Button>
        <Button variant='primary' onClick={onApply}>
          Apply mapping
        </Button>
      </div>
    </BootstrapModal.Footer>
  )
}

export function interleaveWithSeparator<T>(items: T[], separator: T): T[] {
  if (items.length <= 1) return items
  return items.flatMap((item, index) => (index < items.length - 1 ? [item, separator] : [item]))
}

export const DEFAULT_SEPARATOR: FieldDescriptor = { value: ', ', type: 'static' }

export const toCamelCase = (str: string): string => {
  const camelCaseString = str
    .replace(/[^a-zA-Z0-9\s]/g, '')
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (match, index) => (index === 0 ? match.toLowerCase() : match.toUpperCase()))
    .replace(/\s+/g, '')
  return camelCaseString.slice(0, 64)
}
